"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

// Get a Babel location mixin that surrounds all the given nodes.
exports.default = function getSurroundingLoc(nodes) {
  var minLine = Number.POSITIVE_INFINITY,
      maxLine = Number.NEGATIVE_INFINITY;
  var minCol = Number.POSITIVE_INFINITY,
      maxCol = Number.NEGATIVE_INFINITY;
  var minStart = Number.POSITIVE_INFINITY,
      maxEnd = Number.NEGATIVE_INFINITY;

  for (var _i2 = 0, _len2 = nodes.length; _i2 < _len2; _i2++) {
    var _node = nodes[_i2];

    if (_node.start && _node.start < minStart) minStart = _node.start;
    if (_node.end && _node.end > maxEnd) maxEnd = _node.end;
    if (_node.loc) {
      if (_node.loc.start) {
        if (_node.loc.start.line < minLine) minLine = _node.loc.start.line;
        if (_node.loc.start.column < minCol) minCol = _node.loc.start.column;
      }if (_node.loc.end) {
        if (_node.loc.end.line > maxLine) maxLine = _node.loc.end.line;
        if (_node.loc.end.column > maxCol) maxCol = _node.loc.end.column;
      }
    }
  }

  if (isFinite(minLine) && isFinite(minCol) && isFinite(minStart)) {
    return {
      start: minStart,
      end: maxEnd,
      loc: {
        start: { line: minLine, column: minCol },
        end: { line: maxLine, column: maxCol }
      }
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/ast-loc-utils/lib/getSurroundingLoc.js
// module id = 987
// module chunks = 0